// import { SchemeTypes } from '../../../../config';
import { LanguagesEnum } from '../../../../config/languages';

const CONFIGURATION = {};

export const Translations = {
  header: {
    [LanguagesEnum.English]: 'Corrections to VAT Returns (up to 3 Years back)',
    [LanguagesEnum.Greek]: 'Corrections to VAT Returns (up to 3 Years back)',
  },
  add_correction: {
    [LanguagesEnum.English]: 'Add Correction',
    [LanguagesEnum.Greek]: 'Add Correction',
  },
};

export default CONFIGURATION;
